import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./Bob.css";

export default function Bob() {
  return (
    <div className="bob">
      <span className="bob-label">Chat with us!</span>

      <a
        className="bob-wa"
        href="https://wa.me/917880788799"
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp"
      >
        <FaWhatsapp className="bob-icon" />
      </a>
    </div>
  );
}